import { render, staticRenderFns } from "./selectorsPC.vue?vue&type=template&id=2550f38f&scoped=true"
import script from "./selectorsPC.vue?vue&type=script&lang=js"
export * from "./selectorsPC.vue?vue&type=script&lang=js"
import style0 from "./selectorsPC.vue?vue&type=style&index=0&id=2550f38f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550f38f",
  null
  
)

export default component.exports